module.exports = __webpack_public_path__ + "img/1200px-RAF_roundel.svg.32a5bc70.png";